// estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default{
    // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
    namespaced :true,

    state : {

        titulo: "Cargando ...",
        estado: false,
        color: "danger",
        colorDialog: "red",
        ancho: "600"
    },
    // cambia los estados de las variables principales
    // de las variables princiaples

    mutations : {

        viewLoading(state, payload) {
            state.estado = true
            state.titulo =  ( (payload.titulo == null) || (payload.titulo == "") ) ? "Cargando ..." : payload.titulo
            state.color =   ( (payload.color == null) || (payload.color == "") ) ? "#fff" : payload.color 
            state.colorDialog = ( (payload.colorDialog == null) || (payload.colorDialog == "") ) ? "#212121" : payload.colorDialog
            state.ancho = ( (payload.ancho == null) || (payload.ancho == "") ) ? "300" : payload.color 
          },

          closeLoading(state) {
            state.estado = false;
          },


    },

    // crea una copía de los estado iniciales del store (state)
    getters : {},
    actions : {}
}

/*
    ////////////////////////
    ////  Uso        ///
    /////////////////////////
    import {mapMutations} from 'vuex'
  ...mapMutations('loading', ['viewLoading', 'closeLoading']),
    methods: {
             enviarMensaje() {
            
     async loadMain(){
                try{
               
                    // Simple ó  
                    this.viewLoading({});
                     // full 
                    this.viewLoading( {
                        titulo: "",
                        color: "#fff",
                        colorDialog: "#212121",
                        ancho: 300,
                    }); 
                    
                    let params ={id_empresa: this.session.id_empresa, limit:true }
                    let response = await axios.post("/agremiado/agremiado/getView",{filtro:params})
                    this.Datos   = response.data
                    this.closeLoading()

                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        this.closeLoading()
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },


            },
*/